import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type GetMembersQuery =
  operations['KcplaaMemberController_getKcplaaCsMemberList']['parameters']['query'];
type GetMembersHeaders =
  operations['KcplaaMemberController_getKcplaaCsMemberList']['parameters']['header'];

interface GetMembersProps {
  query: GetMembersQuery;
  headers?: OmitGroupIdInHeader<GetMembersHeaders>;
}

type GetMembersResponse = components['schemas']['List$KcplaaCsMemberView$mZFLkyvTelC5g8XnyQrpOw'];

export const getMembers = async ({
  query,
  headers,
}: GetMembersProps): Promise<GetMembersResponse | false> => {
  const response = await authenticateRequest<GetMembersResponse>({
    method: 'get',
    url: `/api/v1/kcplaa/members`,
    headers,
    params: query,
  });

  console.log('getMembers', { response });
  return response;
};

export type { GetMembersQuery };
